export default "__VITE_ASSET__DLRdqYun__"